import { render, staticRenderFns } from "./EventTypeForm.vue?vue&type=template&id=06481f4f"
import script from "./EventTypeForm.vue?vue&type=script&lang=js"
export * from "./EventTypeForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports